import React from 'react';

class RowItemKetQuaThanhTraLai extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.tongSoCuocThanhTraLai}</td>
        <td className='txt-center'>{data.kyTruocChuyenSang}</td>
        <td className='txt-center'>{data.trienKhaiTrongKyBaoCao}</td>
        <td className='txt-center'>{data.ketThucThanhTraTrucTiep}</td>
        <td className='txt-center'>{data.daBanHanhKetLuan}</td>
        <td className='txt-center'>{data.viPhamTrinhTu}</td>
        <td className='txt-center'>{data.ketLuanKhongPhuHop}</td>
        <td className='txt-center'>{data.saiLamApDungPhapLuat}</td>
        <td className='txt-center'>{data.coYLamSaiLechHoSo}</td>
        <td className='txt-center'>{data.viPhamNghiemTrong}</td>
        <td className='txt-center'>{data.soDonViDaThanhTraLai}</td>
        <td className='txt-center'>{data.soDonViCoViPham}</td>
        <td className='txt-center'>{data.viPhamVeKinhTeTien}</td>
        <td className='txt-center'>{data.viPhamVeKinhTeDat}</td>
        <td className='txt-center'>{data.kienNghiThuHoiTien}</td>
        <td className='txt-center'>{data.kienNghiThuHoiDat}</td>
        <td className='txt-center'>{data.kienNghiKhacTien}</td>
        <td className='txt-center'>{data.kienNghiKhacDat}</td>
        <td className='txt-center'>{data.hanhChinhToChuc}</td>
        <td className='txt-center'>{data.hanhChinhCaNhan}</td>
        <td className='txt-center'>{data.chuyenCoQuanDieuTraVu}</td>
        <td className='txt-center'>{data.chuyenCoQuanDieuTraDoiTuong}</td>
        <td className='txt-center'>{data.ketQuaThucHienTienDaThu}</td>
        <td className='txt-center'>{data.ketQuaThucHienDatDaThu}</td>
        <td className='txt-center'>{data.ketQuaThucHienToChuc}</td>
        <td className='txt-center'>{data.ketQuaThucHienCaNhan}</td>
        <td className='txt-center'>{data.ketQuaThucHienVu}</td>
        <td className='txt-center'>{data.ketQuaThucHienDoiTuong}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemKetQuaThanhTraLai;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemKetQuaThanhTraLai.jsx